import instructionImg1 from "../../../images/ipmetInstructionEn.jpg";
import instructionImgHi1 from "../../../images/insthi1.png";
import instructionImgHi2 from "../../../images/insthi2.png";
import instructionImgHi3 from "../../../images/insthi3.png";

const instructioncontentIpmat = {
  en: `<img src="${instructionImg1}"  alt="Instructions" />`,
  hi: `<img src="${instructionImgHi1}"  alt="Instructions" /></p><p><img src="${instructionImgHi2}"  alt="Instructions" /></p><p><img src="${instructionImgHi3}"  alt="Instructions" /></p>`,
};
export default instructioncontentIpmat; 